(function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "";

    /* helper liberary */
    var _$;
    !(function (factory) {
      _$ = factory();
    })(function () {
      var bm = function (s) {
        if (typeof s === "string") {
          this.value = Array.prototype.slice.call(document.querySelectorAll(s));
        }
        if (typeof s === "object") {
          this.value = [s];
        }
      };
      bm.prototype = {
        eq: function (n) {
          this.value = [this.value[n]];
          return this;
        },
        each: function (fn) {
          [].forEach.call(this.value, fn);
          return this;
        },
        live: function (selector, event, callback, context) {
          /****Helper Functions****/
          // helper for enabling IE 8 event bindings
          function addEvent(el, type, handler) {
            if (el.attachEvent) el.attachEvent("on" + type, handler);
            else el.addEventListener(type, handler);
          }
          // matches polyfill
          this.Element &&
            (function (ElementPrototype) {
              ElementPrototype.matches =
                ElementPrototype.matches ||
                ElementPrototype.matchesSelector ||
                ElementPrototype.webkitMatchesSelector ||
                ElementPrototype.msMatchesSelector ||
                function (selector) {
                  var node = this,
                    nodes = (node.parentNode || node.document).querySelectorAll(
                      selector
                    ),
                    i = -1;
                  while (nodes[++i] && nodes[i] != node);
                  return !!nodes[i];
                };
            })(Element.prototype);
          // live binding helper using matchesSelector
          function live(selector, event, callback, context) {
            addEvent(context || document, event, function (e) {
              var found,
                el = e.target || e.srcElement;
              while (
                el &&
                el.matches &&
                el !== context &&
                !(found = el.matches(selector))
              )
                el = el.parentElement;
              if (found) callback.call(el, e);
            });
          }
          live(selector, event, callback, context);
        },
        waitForElement: function (
          selector,
          trigger,
          delayInterval,
          delayTimeout
        ) {
          var interval = setInterval(function () {
            if (_$(selector).value.length) {
              clearInterval(interval);
              trigger();
            }
          }, delayInterval);
          setTimeout(function () {
            clearInterval(interval);
          }, delayTimeout);
        },
      };
      return function (selector) {
        return new bm(selector);
      };
    });

    const priceHtml = `<div class="bm-price"></div>`;

    function getPrice() {
      const priceContainer = document.querySelector(
        ".yotpo-selling-plans .yotpo-selected .yotpo-subscription-price-label-wrapper .yotpo-subscription-label-price"
      );
      const price = document.querySelector(".bm-price");
      if (priceContainer && price) {
        var discountedPrice = priceContainer.innerHTML;
        price.innerHTML = discountedPrice;
        console.log(document.querySelector(".bm-price").innerHTML);
      }
    }
 
    var helper = _$();
    /* Variation Init */
    function init() {
      console.log("inside");
      
      document.querySelector('body').classList.add('BQ007');

      const setPriceSeclector = document.querySelector(
        ".product__info-wrapper .product__info-container .price__container .price__regular .price-item"
      );
      if (document.querySelector(".bm-price")) return;
      setPriceSeclector.insertAdjacentHTML("afterend", priceHtml);
      getPrice();

      helper.live(".yotpo-selling-plans .yotpo-radio-buttons", w3elem, () => {
        getPrice();
      },{passive:true});
    }

    /* Initialise variation */
    helper.waitForElement(
      ".yotpo-selling-plans-wrapper .yotpo-radio-subscription-container",
      init,
      50,
      50000
    );
  } catch (e) {
    if (debug) console.log(e, "error in Test" + variation_name);
  }
})();